require('./angular-resource');
module.exports = 'ngResource';



/*****************
 ** WEBPACK FOOTER
 ** ./~/angular-resource/index.js
 ** module id = 906
 ** module chunks = 8
 **/